export const defaultCountryCode = '91';

export const germanyCountryCode = '49';

export const MEMBER_PHONE_NUMBER_MAX_LENGTH = 15;
